import React from 'react';
import { CardView } from '@workday/upc-common';
import { useTrustedDeviceMutation } from '../../../slices/auth-api.slice';
import { useTranslation } from 'react-i18next';
import styles from './TrustedDevice.module.scss';
import { AddTrustDevice } from './AddTrustDevice';

export function TrustedDevice() {
    const { t } = useTranslation('auth');

    const [trustedDevice, { isLoading }] = useTrustedDeviceMutation();

    function onSubmit() {
        trustedDevice({ trustThisDevice: true });
    }

    function onSkip() {
        trustedDevice({ trustThisDevice: false });
    }

    return (
        <CardView className={styles.trustedDeviceCard}>
            <AddTrustDevice
                disabled={isLoading}
                onSubmit={onSubmit}
                onSkip={onSkip}
                title={t('TrustedDevice.title')}
                subtitle={t('TrustedDevice.description')}
                submitText={t('TrustedDevice.submitButton')}
                skipText={t('TrustedDevice.noThanksButton')}
            />
        </CardView>
    );
}
